import { useState } from "react";
import { Row, Col } from "react-bootstrap"
import "../scss/report.scss"
import { Table } from 'antd';
import Loading from "../../customer/Loading";

import 'antd/dist/antd.min.css'

const Rating = (props) => {
    const [showLoading, setShowLoading] = useState(false)
    const [pageSize, setPageSize] = useState(10)

    function convertDateTime(event) {
        let date = new Date(event),
            month = date.getMonth() + 1,
            day = date.getDate();
        if (day < 10) day = '0' + day;
        if (month < 10) month = '0' + month;
        let text = date.getFullYear() + '-' + month + '-' + day ;

        return text
    };

    const columns = [
        {
            title: 'Tên khách',
            dataIndex: 'customers',
            // align: "center",
            width: 100,
            render: (data) => {
                return (
                    <p className="text1">{data.full_name}</p>
                )
            },
        },
        {
            title: 'Số điện thoại',
            dataIndex: 'customers',
            // align: "center",
            width: 100,
            render: (data) => {
                return (
                    <p className="">{data.mobile}</p>
                )
            },
        },
        {
            title: 'Mã order',
            dataIndex: 'order_code',
            // align: "center",
            width: 100,
            render: (data) => {
                return (
                    <p className="">{data}</p>
                )
            },
        },
        {
            title: 'Ngày lên đơn',
            dataIndex: 'order_at',
            // align: "center",
            width: 100,
            render: (data) => {
                return (
                    <p className="text4">{convertDateTime(data)}</p>
                )
            },
        },
        {
            title: 'Dịch vụ sử dụng',
            dataIndex: 'orderItem',
            align: "center",
            width: 100,
            render: (data) => {
                    let string = ''
                    for(let item of data) {
                        string += `<p className="text1">${item.product_name}</p>`
                    }
                    return (<div dangerouslySetInnerHTML={{__html: string}} />)
                
            },
        },
        {
            title: 'Số sao đánh giá',
            dataIndex: 'rating',
            align: "center",
            width: 100,
            render: (data) => {
                return (
                    <p className="text2">{data} sao</p>
                )
            },
        }
    ];
    const  handleChange = (e) => {
        setPageSize(e.pageSize)
    }

    return (
        <>
            <div style={{ backgroundColor: "white" }} className="p-2">
                <div className="border-bottom w-100 pb-2">
                    <Row>
                        <Col xs={6}>
                            <div>
                                Bảng số liệu chi tiết
                            </div>
                        </Col>
                    </Row>
                </div>
                <Table 
                    columns={columns} 
                    dataSource={props.table}
                    pagination={{ pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ['10', '15', '30', '50', '100'] }}
                    scroll={{ x: 350 }}
                    onChange={handleChange}
                    bordered
                    rowKey="id"
                />
            </div>
            <Loading show={showLoading} />
        </>
    )
}
export default Rating